<template>
    <div id="pettyCashComponent">
      <page-title :heading="$t('pettyCash.title')" :subheading=subheading :icon=icon></page-title>
      <v-container>
        <v-layout wrap>
          <v-flex xs12 sm3 md3>
            <v-text-field v-model="userSearch" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm9 md9 text-sm-right>
            <v-layout row wrap align-center justify-end>
              <v-select
                class="download-users fixed-height mr-2"
                v-model="downloadUsers"
                :items="users"
                :label="$t('expenseDetailEmployee.allEmployees')"
                item-text="name"
                item-value="id"
                multiple
                clearable
                solo
                hide-details>
                <template v-slot:selection="{ item, index }">
                  <div v-if="index === 0" class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                    {{ item.name }}
                  </div>
                  <span v-if="index === 1" class="grey--text caption ml-1">(+{{ downloadUsers.length - 1 }})</span>
                </template>
              </v-select>
              <v-menu
                v-model="downloadMonthMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="download-month mr-2"
                    v-model="downloadMonth"
                    :label="$t('general.month')"
                    prepend-icon="event"
                    readonly
                    hide-details
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  type="month"
                  :locale="$t('general.locale')"
                  v-model="downloadMonth"
                  @input="downloadMonthMenu = false">
                </v-date-picker>
              </v-menu>
              <v-btn @click="downloadCompanyDetail" :loading="loading3" :disabled="loading3 || !downloadMonth" color="primary" round depressed>
                <v-icon left>get_app</v-icon> {{$t('pettyCash.downloadHistory')}}
              </v-btn>
              <v-btn @click="downloadRequestReport" :loading="loading4" :disabled="loading4 || !downloadMonth" color="primary" round depressed>
                <v-icon left>get_app</v-icon> {{$t('pettyCash.downloadRequests')}}
              </v-btn>
              <v-btn @click="createDialog = true" color="primary" outline round>
                <v-icon left>attach_money</v-icon> {{$t('pettyCash.title')}}
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-data-table
        :search="userSearch"
        class="elevation-1"
        :headers="headers"
        :items="pettyCash"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
        >
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                  {{header.text}}</h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="text-sm-center">{{props.item.name}}</td>
              <td class="text-sm-center">{{props.item.period_start_date}}</td>
              <td class="text-sm-center">{{props.item.period_end_date}}</td>
              <td class="text-sm-center">{{props.item.description}}</td>
              <td class="text-sm-center">{{props.item.amount | formatCurrency}}</td>
              <td class="text-sm-center text-justify">
                <v-layout row justify-center>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="info"
                        outline
                        small
                        icon
                        @click="addCash(props.item)">
                        <v-icon small>add</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('pettyCash.makeMovement') }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="info"
                        outline
                        small
                        icon
                        @click="editItem(props.item)">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="info"
                        outline
                        small
                        icon
                        @click="watchHistory(props.item)">
                        <v-icon small>history</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.history') }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" @click="removePetty(props.item)" color="error" outline small icon>
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.remove') }}</span>
                  </v-tooltip>
                </v-layout>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="createDialog" max-width="600px" persistent>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{ formTitle }}</h2>
            </v-toolbar>
            <v-card-text>
              <v-form lazy-validation ref="form" v-model="valid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select v-model="editedItem.isPettyCash" :items="requestType" :disabled="true" required :label="$t('general.type')" item-value="id" item-text="name" :rules="rules.required" @change="viewCardNumber(editedItem.is_amex, editedItem)" :error-messages="errors.is_amex">
                      </v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-model="editedItem.core_user_id" @change="showCardNumber(editedItem.core_user_id)" :label="$t('general.employee')" :items="users" :disabled="editable" required :rules="rules.required" :error-messages="errors.core_user_id" item-value="id" item-text="name"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field v-model="editedItem.description" :rules="rules.required" :label="$t('general.description')" :error-messages="errors.description" clearable required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-if="editedIndex === -1" class="currency-field">
                      <v-text-field v-model="editedItem.amount" :label="$t('restriction.rt.amount')" :rules="rules.decimalMax2" :error-messages="errors.amount" required type="number" prepend-icon="attach_money" clearable></v-text-field>
                      <span class="currency-tag">{{ tagMoneda }}</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="close" color="primary" flat round>{{$t('general.cancel')}}</v-btn>
              <v-btn @click="validate()" :loading="loading" :disabled="loading" color="primary" depressed round>{{$t('general.submit')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="paymentDialog" max-width="600px" persistent>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{ $t('pettyCash.add') }}</h2>
            </v-toolbar>
            <v-card-text>
              <v-form
                lazy-validation
                ref="paymentForm"
                v-model="validPayment"
              >
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs6 sm12 md6>
                      <h3><span class="font-weight-black primary--text">{{$t('general.user')}}: </span>{{paymentCash.user.name}}</h3>
                    </v-flex>
                    <v-flex xs6 sm12 md6>
                      <h3><span class="font-weight-black primary--text">{{$t('pettyCash.currentAmount')}}: </span>{{paymentCash.amount | formatCurrency}}</h3>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <b-form-group class="my-0" :label="$t('pettyCash.movementType')" label-size="sm">
                        <b-form-radio-group
                          button-variant="outline-primary"
                          v-model="paymentType"
                          :options="paymentOptions"
                          buttons
                        ></b-form-radio-group>
                      </b-form-group>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        clearable
                        required
                        :label="$t('general.description')"
                        v-model="paymentCash.description"
                        :rules="rules.required"
                        :error-messages="errors.description">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        clearable
                        required
                        prepend-icon="attach_money"
                        :label="$t('restriction.rt.amount')"
                        v-model="paymentCash.cash"
                        :rules="rules.required && rules.decimal"
                        :error-messages="errors.amount">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6 v-if="paymentType === 1">
                      <v-menu
                        v-model="transactionDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            clearable
                            required
                            :rules="rules.required"
                            v-model="paymentCash.transaction_date"
                            :error-messages="errors.transaction_date"
                            :label="$t('general.transactionDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          :locale="$t('general.locale')"
                          v-model="paymentCash.transaction_date"
                          @input="transactionDate = false">
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                round
                @click="close"
              >{{$t('general.cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                depressed
                round
                @click="validatePayment()"
              >{{$t('general.submit')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="historyDialog" max-width="800px" persistent scrollable>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{ $t('pettyCash.history') }}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <h3><span class="font-weight-black primary--text">{{$t('general.user')}}: </span>{{itemHistory.name ? itemHistory.name : ''}}</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <h3><span class="font-weight-black primary--text">{{$t('general.description')}}: </span>{{itemHistory.small_box ? itemHistory.small_box[0].description : ''}}</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <h3><span class="font-weight-black primary--text">{{$t('general.startDate')}}: </span>{{itemHistory.small_box ? itemHistory.small_box[0].period_start_date : ''}}</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <h3><span class="font-weight-black primary--text">{{$t('general.endDate')}}: </span>{{itemHistory.small_box ? itemHistory.small_box[0].period_end_date : ''}}</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <h3><span class="font-weight-black primary--text">{{$t('restriction.rt.amount')}}: </span>{{itemHistory.small_box ? itemHistory.small_box[0].amount : 0 | formatCurrency}}</h3>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row>
                  <v-flex xs12>
                    <v-data-table
                    :search="search"
                    class="elevation-1"
                    :headers="headersHistory"
                    :items="itemHistory.small_box ? itemHistory.small_box[0].small_box_details : []"
                    :rows-per-page-items="[10,15,25]"
                    :pagination.sync="historyPagination"
                    hide-actions
                    >
                      <template v-slot:headers="props">
                        <tr class="bg-heavy-rain">
                          <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="['column', header.sortable ? 'sortable' : '', historyPagination.descending ? 'desc' : 'asc', header.value === historyPagination.sortBy ? 'active' : '']"
                            @click="changeSort(header.value)"
                          >
                            <h2 class="font-weight-black primary--text mb-0">
                              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                              {{header.text}}</h2>
                          </th>
                        </tr>
                      </template>
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-sm-center">{{props.item.id}}</td>
                          <td class="text-sm-center">{{props.item.created_at}}</td>
                          <td class="text-sm-center" v-if="props.item.type_transaction_id === 1">{{props.item.description}}</td>
                          <td class="text-sm-center" v-if="props.item.type_transaction_id === 2">
                            <span v-if="props.item.description">{{props.item.description}}</span>
                            <span v-else>
                              {{$t('pettyCash.payment')}} - {{$t('workflowValidation.expense')}} {{props.item.expense_id}}
                            </span>
                            </td>
                          <td class="text-sm-center">
                            <v-tooltip bottom v-if="props.item.type_transaction_id === 1">
                              <template v-slot:activator="{ on }">
                                <v-chip
                                v-on="on"
                                  color="bg-success"
                                  class="font-weight-black"
                                  dark
                                  small
                                >+ {{props.item.amount | formatCurrency}}</v-chip>
                              </template>
                              <span class="font-weight-black">{{$t('pettyCash.income')}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="props.item.type_transaction_id === 2">
                              <template v-slot:activator="{ on }">
                                <v-chip
                                v-on="on"
                                  color="bg-danger"
                                  class="font-weight-black"
                                  dark
                                  small
                                >- {{props.item.amount | formatCurrency}}</v-chip>
                              </template>
                              <span class="font-weight-black">{{$t('pettyCash.expense')}}</span>
                            </v-tooltip>
                          </td>
                          <!-- <td class="text-sm-center">{{props.item.end_date}}</td> -->
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                round
                @click="close"
              >{{$t('general.close')}}</v-btn>
              <v-btn
                :loading="loading2"
                :disabled="loading2"
                color="primary"
                round
                depressed
                @click="downloadUserHistory"
              >
                <v-icon left>get_app</v-icon>
                {{$t('pettyCash.downloadHistory')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-dialog v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('pettyCash.removePetty') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('pettyCash.removeQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('pettyCash.currentAmount') }}: </span>"{{removedItem.small_box ? removedItem.small_box.amount : '' | formatCurrency}}"</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('general.user') }}: </span>"{{removedItem.name ? removedItem.name : ''}}"</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="removeDialog = false" color="error darken-1" round flat>
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn @click="deletePetty(removedItem)" :loading="loading" :disabled="loading" color="error" round depressed>
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-container>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
export default {
  name: 'pettyCashComponent',
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      tagMoneda: '',
      settings: {},
      currencySetting: {},
      waitingMessage: '',
      errorMessage: false,
      hadAmex: false,
      search: '',
      userSearch: '',
      errors: {},
      editable: false,
      start: false,
      end: false,
      createDialog: false,
      transactionDate: false,
      downloadMonthMenu: false,
      // Mes (YYYY-MM) del que se descarga el detalle de caja chica de la empresa.
      downloadMonth: new Date().toISOString().substr(0, 7),
      // Filtro opcional de la descarga: vacío = todos los usuarios de la empresa.
      downloadUsers: [],
      dialogBatch: false,
      batchLoaded: false,
      itemsBatch: [],
      itemsBatchErrors: [],
      satPais: [],
      paginationBatch: {
        page: 1,
        sortBy: '',
        rowsPerPage: 100
      },
      paymentDialog: false,
      historyDialog: false,
      removeDialog: false,
      loading: false,
      loadingItems: true,
      loading2: false,
      loading3: false,
      loading4: false,
      valid: true,
      validPayment: true,
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 1000, // -1 for All",
        totalItems: 0
      },
      historyPagination: {
        descending: true,
        sortBy: 'created_at',
        page: 1,
        rowsPerPage: -1, // -1 for All",
        totalItems: 0
      },
      users: [],
      itemHistory: {},
      defaultHistory: {},
      pettyCash: [],
      editedIndex: -1,
      paymentCash: {
        description: '',
        amount: '',
        cash: '',
        user: {
          id: '',
          name: ''
        },
        transaction_date: ''
      },
      paymentType: 1,
      defaultCash: {
        description: '',
        amount: '',
        cash: '',
        user: {
          id: '',
          name: ''
        },
        transaction_date: ''
      },
      editedItem: {
        core_user_id: null,
        user: {
          id: '',
          name: '',
          card_number: null,
          card_number2: null
        },
        start_date: '',
        end_date: '',
        description: '',
        amount: '',
        currency: {},
        isPettyCash: 1,
      },
      removedItem: {
        user: {
          id: '',
          name: ''
        },
        start_date: '',
        end_date: '',
        description: '',
        amount: ''
      },
      defaultItem: {
        core_user_id: null,
        user: {
          id: '',
          name: '',
          card_number: null,
          card_number2: null
        },
        start_date: '',
        end_date: '',
        description: '',
        amount: '',
        currency: {},
        isPettyCash: 1,
      },
      selected: [],
      requestType: [
        { name: this.$t('pettyCash.title'), id: 1 }
      ],
      viewCardNumberTxt: true
    }
  },
  computed: {
    heading () {
      return this.$t('pettyCash.title')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fa fa-wallet fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: this.$t('general.employee'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.startDate'),
          align: 'center',
          value: 'small_box.period_start_date',
          sortable: true
        },
        {
          text: this.$t('general.endDate'),
          align: 'center',
          value: 'small_box.period_end_date',
          sortable: true
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'small_box.description',
          sortable: true
        },
        {
          text: `${this.$t('restriction.rt.amount')} ${this.tagMoneda}`,
          align: 'center',
          value: 'amount',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    headersHistory () {
      return [

        {
          text: '#',
          align: 'center',
          sortable: false
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'created_at',
          sortable: false
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('restriction.rt.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        }
      ]
    },
    headersBatch () {
      return [
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'is_valid'
        },
        {
          text: this.$t('general.name'),
          align: 'left',
          sortable: true,
          value: 'row.full_name'
        },
        {
          text: this.$t('pettyCash.cardNumber'),
          align: 'left',
          sortable: true,
          value: 'row.card_number'
        },
        {
          text: this.$t('pettyCash.transactionDate'),
          align: 'left',
          sortable: true,
          value: 'row.carge_date'
        },
        {
          text: this.$t('pettyCash.vendor'),
          align: 'left',
          sortable: true,
          value: 'row.supplier_name'
        },
        {
          text: this.$t('pettyCash.transactionNumber'),
          align: 'left',
          sortable: true,
          value: 'row.transaction_number'
        },
        {
          text: this.$t('pettyCash.description'),
          align: 'left',
          sortable: true,
          value: 'row.description'
        },
        {
          text: this.$t('pettyCash.amount'),
          align: 'left',
          sortable: true,
          value: 'row.amount'
        },
        {
          text: this.$t('pettyCash.type'),
          align: 'left',
          sortable: true,
          value: 'row.amount'
        }
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('pettyCash.title') : this.$t('pettyCash.edit')
    },
    rules () {
      return this.$validationRules()
    },
    paymentOptions () {
      return [
        {value: 1, text: this.$t('general.add')},
        {value: 2, text: this.$t('pettyCash.withdraw')}
      ]
    }
  },
  watch: {
    settings () {
      this.filterCurrency()
    },
    '$store.state.userLogged' () {
      if (this.$store.state.userLogged.company) {
        this.get()
      }
    },
    hadAmex (val) {
      if (!val) {
        this.editedItem.card_number = ''
      }
    },
    editedIndex () {
      if (this.editedIndex !== -1) {
        this.editable = true
      } else {
        this.editable = false
      }
    }
  },
  created () {
    if (this.$store.state.userLogged.company) {
      this.get()
    }
  },
  methods: {
    filterCurrency () {
      const foundCurrencySetting = this.settings.find(x => x.setting_type.name === 'st.currency' && x.company_id === this.$store.state.userLogged.company[0].id)
      this.currencySetting = foundCurrencySetting || { value: { c_Moneda: 'MXN' } }
      this.tagMoneda = this.currencySetting.value.c_Moneda
      this.editedItem.currency = this.currencySetting.value
      this.defaultItem.currency = this.currencySetting.value
    },
    getTotalPages (items, rows) {
      if (items.length <= 100) {
        return 1
      } else {
        if (items.length % rows >= 1) {
          return Math.round(items.length / rows) + 1
        } else {
          return Math.round(items.length / rows)
        }
      }
    },
    downloadTemplate () {
      this.loading = true
      this.$emit('downloadTemplate', {
        context: this
      })
    },
    changeSort (header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    validate () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    validatePayment () {
      this.errors = {}
      if (this.$refs.paymentForm.validate()) {
        this.saveCash()
      }
    },
    saveCash () {
      this.loading = true
      if (this.paymentType === 1) {
        this.paymentCash.is_payment = true
      } else {
        this.paymentCash.is_payment = false
      }
      this.$emit('addCash', {item: this.paymentCash, context: this})
    },
    addCash (item) {
      this.paymentCash.user = item
      this.paymentCash.core_user_id = item.id
      this.paymentCash.amount = item.amount
      this.paymentCash.small_box_id = item.small_box[0].id
      this.paymentDialog = true
    },
    watchHistory (item) {
      this.itemHistory = Object.assign({}, item)
      this.historyDialog = true
    },
    editItem (item) {
      this.editedIndex = this.pettyCash.indexOf(item)
      this.editedItem.period_start_date = item.small_box[0].period_start_date
      this.editedItem.period_end_date = item.small_box[0].period_end_date
      this.editedItem.core_user_id = item.small_box[0].core_user_id
      this.editedItem.description = item.small_box[0].description
      this.editedItem.id = item.small_box[0].id
      this.createDialog = true
    },
    save () {
      this.loading = true
      
      if (this.editedIndex > -1)  return this.$emit('put', {item: this.editedItem, context: this})
      
      this.$emit('post', {item: this.editedItem, context: this})
     
    },
    // Filtros que comparten las dos descargas de la vista. El calendario entrega
    // el mes (YYYY-MM) y los endpoints esperan el rango completo, así que se
    // arma del día 1 al último día de ese mes. Los usuarios son opcionales: si
    // no se elige ninguno se manda undefined y la descarga sale sin filtrar.
    downloadFilters () {
      let [year, month] = this.downloadMonth.split('-').map(Number)
      let lastDay = new Date(year, month, 0).getDate()
      return {
        start_date: `${this.downloadMonth}-01`,
        end_date: `${this.downloadMonth}-${String(lastDay).padStart(2, '0')}`,
        user_id: this.downloadUsers.length ? this.downloadUsers.join(',') : undefined
      }
    },
    downloadCompanyDetail () {
      this.$emit('downloadCompanyDetail', Object.assign({context: this}, this.downloadFilters()))
      this.loading3 = true
    },
    downloadRequestReport () {
      this.$emit('downloadRequestReport', Object.assign({context: this}, this.downloadFilters()))
      this.loading4 = true
    },
    downloadUserHistory () {
      this.$emit('downloadUserHistory', {context: this, user: this.itemHistory.id})
      this.loading2 = true
    },
    removePetty (item) {
      this.removedItem = Object.assign({}, item)
      this.removedItem.id = item.small_box[0].id
      this.removedItem.core_user_id = item.id
      this.removeDialog = true
    },
    deletePetty (item) {
      this.loading = true
      this.$emit('deletePetty', {context: this, item: item})
    },
    close () {
      this.loading = false
      this.createDialog = false
      this.loading2 = false
      this.paymentDialog = false
      this.removeDialog = false
      this.historyDialog = false
      this.hadAmex = false
      this.editedIndex = -1
      this.paymentType = 1
      this.$refs.form.resetValidation()
      this.$refs.paymentForm.resetValidation()
      this.paymentCash = Object.assign({}, this.defaultCash)
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem.user.card_number = null
      this.itemHistory = Object.assign({}, this.defaultHistory)
      this.waitingMessage = ''
      this.errorMessage = false
      this.viewCardNumberTxt = true
    },
    cancelBatch () {
      this.loading = false
      this.dialogBatch = false
      this.batchLoaded = false
      this.itemsBatch = []
      this.itemsBatchErrors = []
      this.selected = []
    },
    closeBatch () {
      this.loading = false
      this.dialogBatch = false
      this.batchLoaded = false
      this.itemsBatch = []
      this.itemsBatchErrors = []
      this.selected = []
      this.$router.push('/toReconcileExpenses')
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.itemsBatch.slice().filter(x => x.is_valid === true)
    },
    activateBatch () {
      this.loading = true
      this.$emit('postMassiveCreate', {
        items: this.selected,
        context: this
      })
    },
    fileBatchUpload (file, response) {
      this.waitingMessage = ''
      this.errorMessage = false
      this.batchLoaded = true
      this.itemsBatch = this.processitemsBatch(response.data)
      this.selected = this.itemsBatch.slice().filter(x => x.is_valid === true)
    },
    fileBatchAdded (file, response) {
      this.waitingMessage = this.$t('general.waitingMessage')
      this.errorMessage = false
    },
    fileBatchReset (file, response) {
      this.waitingMessage = ''
      this.errorMessage = false
    },
    fileBatchError (file, message, xhr) {
      this.errorMessage = true
      this.waitingMessage = message.message
      let response = message
      if (response.data) {
        if (response.data.length > 0) {
          this.batchLoaded = true
          this.itemsBatch = this.processitemsBatch(response.data)
          this.itemsBatchErrors = response.errors
        } else {
          this.showNotification(response.data.message, 'error', -1)
        }
      } else {
        this.showNotification(response.message, 'error', -1)
      }
    },
    processitemsBatch (itemsBatch) {
      let index = 0
      itemsBatch.sort((a, b) => a.is_valid - b.is_valid)
      itemsBatch.forEach(element => {
        element.index = index
        index++
      })
      return itemsBatch
    },
    get () {
      this.$emit('get', {context: this, company_id: this.$store.state.userLogged.company[0].id})
    },
    refresh () {
      this.$emit('refresh', {context: this, company_id: this.$store.state.userLogged.company[0].id})
    },
    showCardNumber (userId) {
      let user = this.users.filter(usr => usr.id === userId)
      if (user !== null) {
        this.editedItem.user.card_number = user[0].card_number
      }
    },
    viewCardNumber (isAmex, item) {
      this.viewCardNumberTxt = isAmex === 1
    }
  }
}
</script>

<style>
#pagination {
  align-items: center !important;
  background: white !important;
  bottom: 0 !important;
  display: flex !important;
  justify-content: center !important;
  position: fixed !important;
  width: 100% !important;
}

.v-data-table {
  overflow-x: auto !important;
  max-width: 100% !important;
}

.error-message {
  color: red !important;
}

.currency-field {
  display: flex;
  align-items: center;
}

.currency-tag {
  margin-left: 5px;
}

#pettyCashComponent .download-month {
  flex: 0 0 auto;
  max-width: 170px;
  padding-top: 0;
}

/* El v-select `solo` mide 56px de alto (.fixed-height); el campo de mes es un
   text-field normal, así que se centran entre sí con align-center del layout. */
#pettyCashComponent .download-users {
  flex: 0 0 auto;
  width: 220px;
  max-width: 220px;
  padding-top: 0;
}

/* Con multiple, el chip/selección no debe empujar el alto del campo. */
#pettyCashComponent .download-users .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/pettyCash.component.vue